import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { AuditLogPage } from 'features/auditLog'
import { canViewAuditLogsPermission } from 'hooks/usePermission'
import { AuditableResource } from 'models'
import { z } from 'zod/v4'

const auditLogSchema = z.object({
  resource: z.array(z.enum(AuditableResource)).optional(),
  performedBy: z.array(z.string()).optional(),
})

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/audit-log')({
  component: AuditLogPage,
  validateSearch: auditLogSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Activity'),
      },
    ],
  }),
  beforeLoad: protectWithAccountPermissions(canViewAuditLogsPermission),
})
